import React from "react";
import "./App.css";
import Footer from "./Footer";
import logoImage from "./images/WazzaScore_Logo2.png";

function DeleteAccount() {
  return (
    <div className="contact-page">
      <header className="privacyHeader">
        <div className="smallLogo" style={{ textAlign: "left", padding: "1rem" }}>
          <a href="/">
            <img
              src={logoImage}
              alt="WazzaScore Logo"
              style={{
                width: "150px",
                height: "auto",
                maxWidth: "80%",
                cursor: "pointer",
              }}
            />
          </a>
        </div>
      </header>

      <main
        style={{
          padding: "1rem",
          maxWidth: "1000px",
          margin: "0 auto",
        }}
      >
        
        <div
          style={{
            width: "100%",
            height: "100vh",
            maxHeight: "1000px",
            overflow: "hidden",
            borderRadius: "8px",
            boxShadow: "0 1px 6px rgba(0, 0, 0, 0.1)",
            background: "#fff",
          }}
        >
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSdN7vsnwHqVZtohhWQBMM0XWUizCNmAzqvv8J0NG_x7HLQHbg/viewform?embedded=true"
            width="100%"
            height="100%"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="Contact Form"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          >
            Loading…
          </iframe>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default DeleteAccount;
